import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import CookiePrivacyPolicyPopup from "@insite/content-library/Components/CookiePrivacyPolicyPopup";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode } from "react";
import styled, { css } from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showStorePickupOverlay?: boolean;
    storePickupOverlay?: ReactNode;
    showAddressBookOverlay?: boolean;
    addressBookOverlay?: ReactNode;
}

export interface PageStylesInterface {
    contentWrapper?: InjectableCss;
    breadCrumbContainer?: InjectableCss;
}

const pageStyles: PageStylesInterface = {
    breadCrumbContainer: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            padding-right: 1rem;
                            padding-left: 1rem;
                            max-width: 100%;
                        `,
                        null,
                        null,
                        css`
                            padding-right: 80px;
                            padding-left: 80px;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    contentWrapper: {
        css: css`
            [class^="PageStyle"] {
                padding: 0;
                max-width: 100% !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            css`
                                overflow: hidden;
                            `,
                        ],
                        "max",
                    )}
            }
        `,
    },
};

const styles = pageStyles;

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showStorePickupOverlay,
    storePickupOverlay,
    showAddressBookOverlay,
    addressBookOverlay,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div" {...styles.breadCrumbContainer}>
                    <PageBreadcrumbs />
                </Page>
            )}
            <StyledWrapper {...styles.contentWrapper}>{pageContent}</StyledWrapper>

            {showFooter && footer}
            {showStorePickupOverlay && storePickupOverlay}
            {showAddressBookOverlay && addressBookOverlay}
            <CookiePrivacyPolicyPopup />
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }
    @media print {
        display: block;
    }
`;

export default PageLayout;
